// @flow
import { compose, withPropsOnChange } from 'recompose'
import { reduxForm } from 'redux-form'
import withTranslations from '../../../core/withTranslations'
import withHandleCancel from '../withHandleCancel'
import CharityLegalForm from '../../../ui/forms/charity-legal-form'
import {
  multiValidate,
  validateRequired,
  validatePhoneNumber,
  validateDateNumeric,
  tinNumber,
  validateEmail
} from '../../validations/validations'
import { STRIPE_CONNECT_LINK } from '../../../config/index'

export const translations = withTranslations({
  ownerContactDetailText: 'charity.legalForm.ownerContactDetail',
  ownerContactDetailHelperText: 'charity.legalForm.ownerContactDetailHelper',
  ownerContactDetailHelper2Text: 'charity.legalForm.ownerContactDetailHelper2',
  firstNameLabel: 'forms.field.firstName.label',
  lastNameLabel: 'forms.field.lastName.label',
  emailLabel: 'forms.field.email.label',
  phoneLabel: 'forms.field.phone.label',
  birthdateLabel: 'forms.field.birthdate.label',
  addressLabel: 'forms.field.address.label',
  charityDetailsText: 'charity.legalForm.charityDetails',
  legalNameLabel: 'charity.legalForm.legalNameLabel',
  tinLabel: 'charity.legalForm.tinLabel',
  legalAddressLabel: 'charity.legalForm.legalAddressLabel',
  stripeAccountLabel: 'charity.legalForm.stripeAccountLabel',
  stripeAccountHelperText: 'charity.legalForm.stripeAccountHelper',
  errorNotificationText: 'forms.validation.errorNotification',
  cancelText: 'common:cancel',
  saveText: 'common:save'
})

export const withInitialValuesAndStripe = withPropsOnChange(
  ['charity'],
  ({ charity }) => ({
    initialValues: {
      ownerName: charity.ownerName,
      ownerSurname: charity.ownerSurname,
      ownerEmail: charity.ownerEmail,
      ownerPhone: charity.ownerPhone,
      ownerBirthdate: charity.ownerBirthdate,
      ownerAddress: charity.ownerAddress,
      legalName: charity.legalName,
      tin: charity.tin,
      legalAddress: charity.legalAddress
    },
    showStripeSection: true,
    // Stripe stuff - read here https://stripe.com/docs/connect/standard-accounts
    connectWithStripeLink: STRIPE_CONNECT_LINK,
    showConnectWithStripeButton:
      !charity.stripeAccountId || !charity.stripeConnected
  })
)

type ValuesProps = {
  ownerName: string,
  ownerSurname: string,
  ownerEmail: string,
  ownerPhone: string,
  ownerBirthdate: string,
  ownerAddress: string,
  legalName: string,
  tin: string,
  legalAddress: string
}

export const validate = (values: ValuesProps) => {
  return {
    ownerName: validateRequired(values.ownerName),
    ownerSurname: validateRequired(values.ownerSurname),
    ownerEmail: multiValidate(
      [validateRequired, validateEmail],
      values.ownerEmail
    ),
    ownerPhone: multiValidate(
      [validateRequired, validatePhoneNumber],
      values.ownerPhone
    ),
    ownerBirthdate: multiValidate(
      [validateRequired, validateDateNumeric],
      values.ownerBirthdate
    ),
    ownerAddress: validateRequired(values.ownerAddress),
    legalName: validateRequired(values.legalName),
    tin: multiValidate([validateRequired, tinNumber], values.tin),
    legalAddress: validateRequired(values.legalAddress)
  }
}

const withReduxForm = reduxForm({
  form: 'editCharityLegal',
  validate,
  onSubmit: (values, dispatch, props) =>
    props.onSave(props.charityId, values).then(props.onGoToCharityInfo())
})

export const EditCharityLegalFormEnhancer = compose(
  withInitialValuesAndStripe,
  withReduxForm,
  withHandleCancel,
  translations
)

export default EditCharityLegalFormEnhancer(CharityLegalForm)



// WEBPACK FOOTER //
// ./src/services/mycharity/charity/EditCharityLegalForm.js